import SiteMap from "./site-map";
import SiteMapNavigation from "./site-map-navigation";
import SiteMapOverlay from "./site-map-overlay";

export default function initializeSiteMap() {
    window.customElements.define('site-map', SiteMap);
    window.customElements.define('site-map-navigation', SiteMapNavigation);
    window.customElements.define('site-map-overlay', SiteMapOverlay);
};